module.exports = __webpack_public_path__ + "static/media/bus.de5b00f8.svg";